import React from 'react'

const DeployedTokenCube = ({
  // fill = {
  //   path1: "#B2A5FF",
  //   path2: "#9381FF",
  //   path3: "#A495FF",
  //   circle: "#A697FF"
  // },
  position,
  onClick,
  highlighted,
  totalCount,
  disableTokenHover
}) => {
  return (
    <svg
      x={position.x}
      y={position.y}
      width="18.2"
      height="27.19"
      viewBox="0 0 18.2 27.19"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      fill="none"
      className={disableTokenHover ? '' : 'cursor-pointer'}
    >
      {highlighted && (
        <rect x="0" y="0" width="18.2" height="27.19" fill="#D1E2FE" opacity="0.5" rx="2" />
      )}
      <rect x="1" y="1" width="16.2" height="25.19" rx="2" fill="#DCF06C" stroke="#B2BF65" strokeWidth="1" />

      <foreignObject x="0" y="0" width="18.2" height="27.19">
        <div xmlns="http://www.w3.org/1999/xhtml" className='h-full w-full flex items-center justify-center' >
          <span id="floating-text" className='text-black text-[10px] font-bold'>{totalCount}</span>
        </div>
      </foreignObject>
    </svg>
  )
}

export default DeployedTokenCube